import { useEffect } from 'react';

import { useAppContext } from '../../../store/App/utils/useAppContext';
import {
  startChat,
  startChatFail,
  updateChat,
} from '../../../store/transcript/actions';
import { useTranscriptContext } from '../../../store/transcript/utils/useTranscriptContext';

/**
 * Initialize Chat Session
 */
export const useStartChat = () => {
  const {
    dispatch,
    state: { sessionId, isSessionActive },
  } = useTranscriptContext();
  const {
    endpoints,
    state: { systemId, tenantId, userId },
  } = useAppContext();

  useEffect(() => {
    /**
     * Initialize Chat Session
     */
    if (systemId && tenantId && userId && !isSessionActive) {
      const initPromise = !sessionId
        ? endpoints.initChat({ systemId, tenantId, userId })
        : endpoints.resumeChat?.({ systemId, tenantId, userId }, sessionId) ??
          endpoints.initChat({ systemId, tenantId, userId });

      dispatch(startChat());
      initPromise
        .then((d) => {
          dispatch(updateChat(d));
        })
        .catch(() => {
          dispatch(startChatFail());
        });
    }
  }, [
    dispatch,
    endpoints,
    isSessionActive,
    sessionId,
    systemId,
    tenantId,
    userId,
  ]);
};
